import { render, staticRenderFns } from "./PersonMainInfo.vue?vue&type=template&id=67b4a838"
import script from "./PersonMainInfo.vue?vue&type=script&lang=ts"
export * from "./PersonMainInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports